import { Singleton } from 'typescript-ioc'
import { APIClientBase } from './APIClientBase'

@Singleton
export class AuthAPIClient extends APIClientBase {
  /**
   * Instanciate api client
   */
  constructor () {
    super('auth')
  }
}
